import React from 'react';
import { Col, Row } from 'reactstrap';

import KStatus from '../base/data/KStatus';
import DataStore from '../base/plumbing/DataStore';
import C from '../C';
import ActionMan from '../plumbing/ActionMan';

import Misc from '../base/components/Misc';
import { setWindowTitle, getDataItem, getDataList, publishEdits, saveEdits } from '../base/plumbing/Crud';
import ListLoad from '../base/components/ListLoad';
import PropControl from '../base/components/PropControl';
import SubCard from '../base/components/SubCard';
import LinkOut from '../base/components/LinkOut';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';
import PropControlPlace from '../base/components/propcontrols/PropControlPlace';
import AThing from '../base/data/AThing';
import PropControlList from '../base/components/propcontrols/PropControlList';
import PropControlDataItem from '../base/components/propcontrols/PropControlDataItem';
import ImpactEditor from './ImpactEditor';
import List from '../base/data/List';
import ImpactCredit from '../base/data/ImpactCredit';
import deepCopy from '../base/utils/deepCopy';
import PropControlUrl from '../base/components/propcontrols/PropControlUrl';
import SearchQuery from '../base/searchquery';
import { is, space } from '../base/utils/miscutils';
import Icon from '../base/components/Icon';
import { getBillUrl } from '../data/Xero';
import PortalLink from '../base/components/PortalLink';


const dummy = PropControlPlace; // keep to register the propcontrol for place

/**
 * Provide single-tag and whole-campaign tables for Green Ad Tags.
 * Shows impression counts & data-transfer totals with various single and cross breakdowns.
 * TODO Campaign and tag mode ended up almost identical - abstract them into a single component.
 * @param {} param0 
 * @returns 
 */
function ImpactCreditPage() {
    const type = C.TYPES.ImpactCredit;
    setWindowTitle(type);

    const blocked = Misc.CheckAccess({ can: 'editImpact' });
    if (blocked) return blocked;

    const path = DataStore.getValue(['location', 'path']);
    const itemId = path[1];

    if (!itemId) {
        let agencyId = DataStore.getUrlValue('agencyId');
        let certified = DataStore.getUrlValue('certified');
        let q = agencyId? SearchQuery.setProp(null, "agencyId", agencyId).query : null;
        if (is(certified)) {
            const v = certified? "any" : "unset";
            q = SearchQuery.and(q, "certificateUrl:"+v+" OR certificateFile:"+v).query;
        }
        return <>
        <p><C.A href="#impactallocation">Allocate Credit</C.A></p>
        <PropControlDataItem prop="agencyId" itemType="Agency" label="Agency" />
        <PropControl prop="certified" type="checkbox" label="Has Certificate" />
        <ListLoad q={q} canCreate canFilter type={type} status={KStatus.ALL_BAR_TRASH} ListItem={ImpactCreditListItem} />
        </>;
    }

    const pvItem = ActionMan.getDataItem({ type, id: itemId, status: KStatus.DRAFT });
    if (!pvItem.value) {
        return <><h1>Impact Credit: {itemId}</h1><Misc.Loading /></>;
    }
    const item = pvItem.value;
    setWindowTitle(item);

    return (<>
        <h1>Impact Credit Editor</h1>
        <div><LinkOut className="small" href={"https://good-loop.monday.com/boards/" + MONDAY_BOARD}>monday.com Donations board</LinkOut></div>
        <EditImpactCredit item={item} />
    </>);
}

const MONDAY_BOARD = "2613874238";

/**
 * 
 * @param {Object} p
 * @param {ImpactCredit} p.item
 * @returns 
 */
function EditImpactCredit({ item }) {
    const type = C.TYPES.ImpactCredit;
    const path = DataStore.getDataPath({ status: KStatus.DRAFT, type, id: item.id });
    const ipath = path.concat("impact");
    let unit = item.impact?.name;
    let ngo = item.impact?.charity;
    item.name = [ngo, item.impact?.n, item.impact?.name].filter(x => x).join(" ");

    let pvDebits = getDataList({type:"ImpactDebit", status:KStatus.ALL_BAR_TRASH, q:"creditId:"+item.id});
    let debits = List.hits(pvDebits.value) || [];
    let debit = debits[0]; 
    const setLinkedDebit = debitId => {
        console.warn("set debitId", debitId);
        if ( ! debitId) {
            if (debit) {
                let previous = deepCopy(debit);
                debit.creditId = null;
                if (debit.status===KStatus.PUBLISHED || debit.status===KStatus.MODIFIED) {
                    publishEdits({item:debit, previous}); // Not ideal ...but avoids a bug where this wont go away
                } else {
                    saveEdits({item:debit, previous});  
                }
                DataStore.invalidateList("ImpactDebit");
            }
            return;
        }
        console.warn("debitId", debitId);
        let pvDebit = getDataItem({type:C.TYPES.ImpactDebit, id:debitId, status:KStatus.DRAFT});
        pvDebit.promise.then(_debit => {
            console.warn("TODO set debit", _debit);
            _debit.creditId = item.id;
            saveEdits({item:_debit});
        });
    };

    return <>
        ID: {item.id}

        <h4>Donations</h4>
        {debits.length > 1? debits.map(impd => <PortalLink className="mr-2" item={impd} />)
            : <PropControlDataItem label="Link to ImpactDebit (if 1-to-1)" itemType={C.TYPES.ImpactDebit} 
            set={setLinkedDebit} value={debit?.id} disabled={debits.length > 1} help="Normally ImpactCredit/Debit are in matching pairs" />}

        <PropControlDataItem label="Agency" itemType={C.TYPES.Agency} path={path} prop="agencyId" />
        <PropControlDataItem label="Advertiser" itemType={C.TYPES.Advertiser} path={path} prop="vertiser" />

        <SubCard title="Impact">
            <ImpactEditor ipath={ipath} />
        </SubCard>

        <SubCard title="Audit Trail">
            <PropControl label path={path} prop="certificateId" help="If the charity provides a certificate ID" />

            <Row><Col>
            <PropControl label="Certificate link" path={path} prop="certificateUrl" type="url" 
                help="If the charity provides a certificate or dashboard page we can link to" />
            </Col><Col>
            <PropControl label="Certificate file (or receipt, if no certificate)" path={path} prop="certificateFile" type="upload" 
                help="If the certificate is a pdf" />
            </Col>
            <Col>
                <PropControlList label="Multiple Certificates" path={path} prop="certificates" type="list" 
                help="If there are several certificates (which should be unusual)" subType="url" />
            </Col>
            </Row>

            <PropControl path={path} prop="invoiceNumber" label="Invoice or receipt ID" />

            <PropControl label path={path} prop="bank" help="Which bank did we pay from?" type="select"
                options={["Revolut","The Co-operative bank", "Other"]}
            />

            <PropControl label path={path} prop="paid" type="date" />

            <PropControl label="Xero ID" path={path} prop="xero" 
                append={item.xero && <LinkOut className="input-group-text p-0" href={getBillUrl(item.xero)}><Icon name="link" /></LinkOut>}
            />

        </SubCard>
        <SavePublishDeleteEtc type={C.TYPES.ImpactCredit} id={item.id} canDiscard position="relative" />
    </>;
}


export function ImpactCreditListItem({item, items}) {
    // data QA hack check for overlap
    let isDuplicate;
    if (items && item.xero) {
        let sameXero = items.filter(impc => impc.xero === item.xero);
        isDuplicate = sameXero.length > 1;
    }

	const id = item.id;
	let ngo = item.impact?.charity;
    let name = [ngo, item.impact?.n, item.impact?.name].filter(x => x).join(" ");
	if (name.length > 280) name = name.slice(0, 280);
	const status = item.status || "";
	return <>
		{/* <Misc.Thumbnail item={item} /> */}
		<div className={space("info", isDuplicate&&"bg-danger")}>
			<div className="name">{item.invoiceNumber}: {name}</div>
            <Misc.Money amount={item.impact?.amount} /> {ImpactCredit.certified(item) && <LinkOut href={ImpactCredit.certified(item)}><Icon name="scroll" /> certificate</LinkOut>}
			<div className="detail small">
				id: <span className="id">{id}</span> xero: <LinkOut href={getBillUrl(item.xero)}>{item.xero}</LinkOut> <span className="status">{status.toLowerCase()}</span> Created: <Misc.RoughDate date={item.created} /> {AThing.lastModified(item) && <>Modified: <Misc.RoughDate date={AThing.lastModified(item)} /></>}                
			</div>
		</div>
	</>;
}

export default ImpactCreditPage;
